<template>
	<div v-if="showNotification" class="notification-banner">
		{{ notificationMsg }}
	</div>
</template>

<script>
export default {
	name: "NotificationBanner",
	data() {
		return {
			showNotification: window.portal.show_notification,
			notificationMsg: window.portal.notification_msg
		}
	}
}
</script>

<style>
.notification-banner {
	/*background-color: rgb(251, 146, 60);*/
	background-color: red;
	color: white;
	padding: 1em 0.5em;
	text-align: center;
	font-weight: bold;
	margin-bottom: 1.5em;
}
</style>
